import React, { useState , useEffect} from 'react';
import { useNavigate , useParams } from 'react-router-dom';
import { ToastContainer , toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {getAuthorsApi} from '../../../../services/authors/authorsService';
import { editBlog , singleBlog} from '../../../../services/blogDeepSearch/blogDeepSearchService';
import FormEditBlog from '../../../common/forms/FormEditBlog';
import Loading from '../../../common/loading/Loading';


const EditPost = () => {

    const {id} = useParams();

    const navigate = useNavigate();

    const[loading , setLoading] = useState(true);
    const [loadingForm , setLoadingForm] = useState(false);
    const [ form , setForm ]= useState();
    const [ post , setPost ]= useState({});
    

    useEffect(()=>{
        const getBlogCat = async()=>{

            const res = await singleBlog(id);
            const resAuthors = await getAuthorsApi();


            if(res.data.status === 'success'){
                setPost(res.data.data.blog);
                setForm( {
                    formItems: [
                    {
                        inputType: "input",
                        config: {
                            label: 'Title',
                            name: "title",
                            containerClasses : 'w-1/2 pr-1'
                        },
                        value: res.data.data.blog.title,
                        validation: {
                            required: true,
                        },
                        valid: false,
                        errorMsg: "",
                        used: false
                    },
                    {
                        inputType: "input",
                        config: {
                            label: 'Slug',
                            name: "slug",
                            containerClasses : 'w-1/2 pl-1'
                        },
                        value: res.data.data.blog.slug,
                        validation: {
                            required: true,
                        },
                        valid: false,
                        errorMsg: "",
                        used: false
                    },
                    {
                        inputType: "input",
                        config: {
                            label: 'Seo Description',
                            name: "seoDesc",
                            containerClasses : 'w-full'
                        },
                        value: res.data.data.blog.seoDesc,
                        validation: {
                            required: true,
                        },
                        valid: false,
                        errorMsg: "",
                        used: false
                    },
                    {
                        inputType: "textarea",
                        config: {
                            label: 'Keywords',
                            name: "keywords",
                            containerClasses : 'w-full'
                        },
                        value: res.data.data.blog.keywords,
                        validation: {
                            required: true,
                        },
                        valid: false,
                        errorMsg: "",
                        used: false
                    },
                    {
                        inputType: "select-blog-cat",
                        config: {
                            options : res.data.data.blogCats ,
                            label: 'category',
                            name: "categories",
                            containerClasses : 'w-full'
                        },
                        value: res.data.data.blog.categories,
                        validation: {
                            notEmptyArray: true,
                        },
                        valid: false,
                        errorMsg: "",
                        used: false
                    },
                    {
                        inputType: "ck-editor",
                        config: {
                            label: 'Body',
                            name: "body",
                            containerClasses : 'w-full'
                        },
                        value: res.data.data.blog.body,
                        validation: {
                            required: true,
                        },
                        valid: false,
                        errorMsg: "",
                        used: false
                    },
                    {
                        inputType: "input-file",
                        config: {
                            label: 'Image',
                            name: "images",
                            type: "file",
                            t_label : 'attached_file',
                            containerClasses : 'w-1/2'
                        },
                        value: "",
                        validation: {
                            maxSize: 5000000,
                        },
                        valid: false,
                        errorMsg: "",
                        used: false
                    },
                    {
                        inputType: "input",
                        config: {
                            label: 'Time Read',
                            name: "timeRead",
                            containerClasses : 'w-1/2 pr-1'
                        },
                        value: res.data.data.blog.timeRead,
                        validation: {
                            required: true,
                        },
                        valid: false,
                        errorMsg: "",
                        used: false
                    },
                    {
                        inputType: "select-blog-publication-status",
                        config: {
                            options : [
                                {id : '-1', title : 'draft'} ,
                                {id : '1', title : 'publication'} ,
                            ] ,
                            label: 'Publication status',
                            name: "publicationStatus",
                            containerClasses : 'w-1/2'
                        },
                        value:  res.data.data.blog.publicationStatus ,
                        validation: {
                            selectRequired : true,
                        },
                        valid: false,
                        errorMsg: "",
                        used: false
                    },
                    {
                        inputType: "selectAuthor",
                        config: {
                            options : resAuthors.data.data,
                            label: 'Author',
                            name: "authors",
                            containerClasses : 'w-full'
                        },
                        value: res.data.data.blog.authors[0] ,
                        validation: {
                            selectRequired : true,
                        },
                        valid: false,
                        errorMsg: "",
                        used: false
                    },
                ]
                });

            }else if(res.data.status === 'error'){
                toast.error(res.data.msg);
            }
            setLoading(false);
        }
        getBlogCat();
    } , []);
        


    const handleSubmitForm = async(formData)=>{

        try {
            setLoadingForm(true);
            const {data} = await editBlog(id , formData);
            setLoadingForm(false); 
            if(data.status === 'success'){
                toast.success('This post edited successfull');
                navigate('/blog-deep-search')
    
            }else if(data.status == 'error'){
                toast.error(data.msg);
            }
        } catch (err) {
            toast.error(err.response.data.message);
            setLoadingForm(true);
        }
    }



    return (
        <>
            <ToastContainer 
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored" />


            <div className="container mx-auto p-3 ">
                <div className='bg-white-100 dark:bg-dark-100 p-3 rounded-md text-[0.9rem] font-normal flex flex-col justify-center items-start shadow-my dark:shadow-none '>
                    <div className='w-full flex justify-start items-center mb-5'>
                        <svg className='w-2 h-2 fill-gray-700 dark:fill-white-100 mr-2' viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="50" cy="50" r="50" />
                        </svg>
                        <span className='text-gray-700 dark:text-white-100 text-xl font-extrabold'>Edit Post</span>
                    </div>
                    {
                        loading ? 
                        (
                            <Loading/>
                        )
                        :
                        (
                            <FormEditBlog initForm={form} submit={handleSubmitForm} loading={loadingForm} submitTitle="Apply" file={true} post={post}/>
                        )
                    }

                </div>
            </div>
        </>
    )

}

export default EditPost ;
